import store from '../redux/clientStore';
import {
    setCodesAndPlMapExclusive,
    setEntranceUrl,
    setPartnershopFailed,
    setPartnershopErrors
} from '../redux/sponsorCodeReducer';
import sponsorApi from "./api/sponsors.js";

export const PartnerShopErrors = {
    INVALID: 'invalid',
};


class SponsorCodesService {
    // Seats
    isSeatForSponsorReserved(sponsorReservations, seatIdentifier, redeemedSponsorCodeUsages) {
        const seatReservation = this.getSponsorSeatReservation(sponsorReservations, seatIdentifier)
        return seatReservation && !seatReservation.priorSale && !this.isSeatForRedeemedSponsorCodeReserved(sponsorReservations, seatIdentifier, redeemedSponsorCodeUsages)
    }

    isSeatForRedeemedSponsorCodeReserved(sponsorReservations, seatIdentifier, redeemedSponsorCodeUsages) {
        const seatReservation = this.getSponsorSeatReservation(sponsorReservations, seatIdentifier)
        return seatReservation ? redeemedSponsorCodeUsages.indexOf(seatReservation.codeUsageId.toString()) !== -1 : false
    }

    getSponsorSeatReservation(sponsorReservations, seatIdentifier) {
        const seatReservation = sponsorReservations ? sponsorReservations.find(seatReservation => seatReservation.identifier === seatIdentifier) : null
        return seatReservation ? seatReservation : null
    }

    // FreeSeating
    getFreeSeatingAmountForSponsorReservations(sponsorReservations, seatIdentifier, redeemedSponsorCodeUsages) {
        let amount = 0
        if (sponsorReservations.length > 0) {
            sponsorReservations.forEach(element => {
                if ((element.identifier === seatIdentifier) && (redeemedSponsorCodeUsages.indexOf(element.codeUsageId.toString()) === -1) && !element.priorSale) {
                    amount += element.reserved - element.used
                }
            })
        }
        return amount
    }

    getFreeSeatingAmountForCodeUsage(sponsorReservations, seatIdentifier, codeUsageId) {
        let amount = 0
        sponsorReservations.forEach(element => {
            if (element.identifier === seatIdentifier && element.codeUsageId.toString() === codeUsageId) {
                amount += (element.reserved - element.used)
            }
        })
        return amount
    }

    async applyCode(merchantId, themeName, codeString, entranceLocation) {
        try {
            const merchantState = store.getState().merchant
            const priceLevelCodeUsagesLookupResponse = await sponsorApi.lookupCodeUsagesAndPriceLevel(merchantState.merchantId, merchantState.themeName, codeString);
            if (!priceLevelCodeUsagesLookupResponse.valid) {
                await store.dispatch(setPartnershopErrors([PartnerShopErrors.INVALID]))
            } else {
                store.dispatch(setCodesAndPlMapExclusive([codeString], priceLevelCodeUsagesLookupResponse.codeUsagesPlUuid, entranceLocation))
            }
        } catch (e) {
            console.error('could not lookup pricelevel and code usages for sponsor code', e);
            await store.dispatch(setEntranceUrl(entranceLocation))
            await store.dispatch(setPartnershopFailed())
        }
    }
}

const sponsorCodeService = new SponsorCodesService();
export default sponsorCodeService;
